export default __webpack_public_path__ + "static/media/15.881aa7e7.webp";